<template>
  <div id="AdminHeader" style="position: fixed; width: 100%; z-index: 99">
    <div class="d-flex align-items-center pr-3 py-2 admin-header shadow-sm">
      <!-- <div class="header-project px-3 d-flex align-items-center">
        <img
          class="header-logo-img"
          src="@/assets/logo.png"
          style="height: 47px"
        />
        <span class="px-2 fontsize-h6">กรมท่าอากาศยาน</span>
      </div> -->
      <div class="flex-fill px-3 fontsize-h3 align-items-center weight-600">
        ระบบลงลายมือชื่ออิเล็กทรอนิกส์
        <span class="font-warning">(Digital Signature)</span>
      </div>
      <b-navbar-nav class="mx-2 nav-logout">
        <b-nav-item-dropdown right class="nav-dropdown-logout">
          <template #button-content>
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex flex-column flex-1 text-right">
                <span
                  class="ml-3 mr-2 admin-header-user"
                  style="display: inline-block; min-width: 100px"
                  >{{ usernameLogin }}</span
                >
                <span
                  class="ml-3 mr-2 admin-header-position"
                  style="display: inline-block; min-width: 100px"
                  >{{ positionLogin }}</span
                >
              </div>

              <b-avatar
                class="admin-header-avatar"
                :src="userImage"
                onerror="javascript:this.src='/images/default-profile.png'"
              ></b-avatar>
            </div>
          </template>
          <b-dropdown-item href="#" @click="getLogout"
            ><font-awesome-icon
              class="mr-2 font-danger"
              :icon="['fas', 'power-off']"
            />
            ออกจากระบบ</b-dropdown-item
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "admin-header",
  data() {
    return {
      userImage: null,
    };
  },
  methods: {
    getLogout() {
      this.alertConfirm("คุณต้องการออกจากระบบใช่หรือไม่").then((res) => {
        if (res) {
          this.$store
            .dispatch("account/logout")
            .then(
              (res) => {},
              (error) => {
                console.log("getLogout():error", error);
              }
            )
            .finally(() => {
              this.$router.push({ name: "Login" });
            });
        }
      });
    },
  },
  computed: {
    usernameLogin: function () {
      const detail = this.$utils.main.getUserInfo() || {};
      return `${detail?.firstName || ""} ${detail?.lastName || ""}` || "-";
    },
    positionLogin: function () {
      const detail = this.$utils.main.getUserInfo() || {};
      return detail?.departmentName || "-";
    },
    // userImage: function() {
    //   // const detail = this.$utils.main.getDetail() || {}
    //   // return detail?.image || ''
    // }
  },
};
</script>

<style lang="scss">
.admin-header {
  background: white;
  padding-left: $sidebar-width;
  height: $admin-header-height;
  transition: all $sidebar-delay ease-in-out;

  .app-screen-medium .menu-collapse &,
  .app-screen-large .menu-collapse & {
    height: $admin-header-height-sm;
    padding-left: $sidebar-width-sm;
  }

  .nav-dropdown-logout {
    > a {
      display: flex;
      align-items: center;
    }

    &::before {
      content: "";
      position: absolute;
      top: 0.25rem;
      bottom: 0.25rem;
      left: 0;
      width: 2px;
      background: lighten($darkgray, 40%);
    }
  }

  .admin-header-avatar {
    margin: 0 0.25rem;
  }

  .admin-header-user {
    color: $black;
  }

  .admin-header-position {
    color: $darkgray;
  }
}
</style>
